import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './VerificationModal.css';

const VerificationModal = ({ isOpen, onClose, onConfirm, currentStatus, currentExpiry }) => {
    const { t } = useTranslation();
    const [expiryDate, setExpiryDate] = useState('');

    useEffect(() => {
        if (isOpen) {
            if (currentExpiry) {
                const date = new Date(currentExpiry);
                const formatted = date.toISOString().split('T')[0];
                setExpiryDate(formatted);
            } else {
                setExpiryDate('');
            }
        }
    }, [isOpen, currentExpiry]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm(expiryDate);
    };

    const isUnverifying = currentStatus === true;

    return (
        <div className="v-modal-overlay">
            <div className="v-modal-container">
                <div className="v-modal-header">
                    <h3>{isUnverifying ? t('remove_verification', 'Remover Verificação') : t('verify_artist', 'Verificar Artista')}</h3>
                    <button className="v-modal-close" onClick={onClose}>&times;</button>
                </div>

                <form onSubmit={handleSubmit} className="v-modal-body">
                    {isUnverifying ? (
                        <p className="v-confirm-text">
                            {t('confirm_unverify_text', 'Tem certeza que deseja remover o selo de verificado deste artista?')}
                        </p>
                    ) : (
                        <>
                            <p className="v-hint-text">
                                {t('verify_artist_desc', 'Conceda o selo de verificado para este perfil. Você pode definir uma data de expiração opcional.')}
                            </p>
                            <div className="v-form-group">
                                <label htmlFor="expiry">{t('expiration_date', 'Data de Expiração (Opcional)')}</label>
                                <input
                                    type="date"
                                    id="expiry"
                                    value={expiryDate}
                                    onChange={(e) => setExpiryDate(e.target.value)}
                                    min={new Date().toISOString().split('T')[0]}
                                />
                                <small>{t('leave_empty_unlimited', 'Deixe vazio para verificação ilimitada.')}</small>
                            </div>
                        </>
                    )}

                    <div className="v-modal-footer">
                        <button type="button" className="v-btn-cancel" onClick={onClose}>
                            {t('cancel', 'Cancelar')}
                        </button>
                        <button type="submit" className={isUnverifying ? "v-btn-danger" : "v-btn-confirm"}>
                            {isUnverifying ? t('remove', 'Remover') : t('confirm', 'Confirmar')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default VerificationModal;
